import { IUser } from "../../../context/interfaces/User";
import { defineRight } from "../components/ManageUserTab/helpers/defineRight";
import { ITeam } from "../interfaces/team.interface";

export const canUserEdit = (user: IUser, team: ITeam | null) => {
  if (user.is_superuser) return true;
  if (!team) return false;
  const myRightInThisTeam = defineRight(user, team);
  return (
    user.is_superuser ||
    myRightInThisTeam === "Admin" ||
    myRightInThisTeam === "Editor" ||
    myRightInThisTeam === "Superuser"
  );
};
